// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.vrm-details-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow-y: auto;
}

.vrm-details-container .horizontal-separator {
  width: 100%;
  border-top: 1px solid var(--placeHolderColor);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/VRMDetails/VRMDetails.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,UAAU;AACZ","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.vrm-details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.vrm-details-container .horizontal-separator {\n  width: 100%;\n  border-top: 1px solid var(--placeHolderColor);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
